enum MovieReviewListActionType {
  FETCH_MOVIE_REVIEW_LIST_REQUEST = 'FETCH_MOVIE_REVIEW_LIST_REQUEST',
  FETCH_MOVIE_REVIEW_LIST_REQUEST_SUCCESS = 'FETCH_MOVIE_REVIEW_LIST_REQUEST_SUCCESS',
  FETCH_MOVIE_REVIEW_LIST_REQUEST_ERROR = 'FETCH_MOVIE_REVIEW_LIST_REQUEST_ERROR',
}

export default MovieReviewListActionType
